module.exports = __webpack_public_path__ + "img/checklist_1.a337e318.png";